<template>
  <page :load="doInit">
    <v-layout row wrap>
      <v-flex lg5 xs12 class="mavContainer">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>Online Users ({{totalUsers}})</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <v-btn icon @click="doRefresh" slot="activator">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <span>Refresh List</span>
            </v-tooltip>
          </v-toolbar>
          <v-container fluid class="pa-0 mt-2">
            <v-flex xs12>
              <v-text-field label="Search" v-model="search" single-line full-width hide-details></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-divider></v-divider>
            </v-flex>
          </v-container>
          <v-list>
            <template v-if="totalUsers > 0">
              <template v-for="(user, index) in filteredUsers">
                <v-list-tile avatar v-bind:key="user.userId" @click="doSelectUser(index)">
                  <v-list-tile-avatar>
                    <v-avatar :size="40" class="primary">
                      <span class="white--text">
                        {{formatInitials(user.firstName, user.lastName)}}
                      </span>
                    </v-avatar>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{user.firstName}}, {{user.lastName}}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon small v-if="user.status === 'ONLINE'" color="green">mdi-record</v-icon>
                    <v-icon small v-else-if="user.status === 'AWAY'" color="orange">mdi-record</v-icon>
                    <v-icon small v-else>mdi-record</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </template>
            <template v-else>
              <v-card-text>
                There is no user online
              </v-card-text>
            </template>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex lg7 xs12 class="mavContainer">
        <template v-if="selectedIndex !== undefined">
          <v-card>
            <card-avatar :fname="selectedUser.firstName" :lname="selectedUser.lastName">
            </card-avatar>
            <v-card-actions>
              <v-btn flat color="red" @click="promptDC = true" :loading="submitting">Disconnect User</v-btn>
            </v-card-actions>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-text-field label="Email" v-model="selectedUser.email" readonly hide-details></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-subheader>Sessions</v-subheader>
                  </v-flex>
                  <template v-for="(session, index) in selectedUser.sessions">
                    <v-flex :key="index">
                      <v-flex xs6>
                        <v-text-field label="IP Address" v-model="session.ipAddress" readonly hide-details></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field label="Last Access Time" :value="formatDateTime(session.lastAccessTime)" readonly hide-details></v-text-field>
                      </v-flex>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </template>
      </v-flex>
    </v-layout>
    <confirm v-model="promptDC" @ok="doDC">
      Do you wish to disconnect selected user from the system?
    </confirm>
  </page>
</template>

<script>
import CardAvatar from '@/components/reusable/CardAvatar'
import { initials } from '@/utils/name'
import { formatDisplayDateTime } from '@/utils/date'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      users: [],
      search: '',
      selectedIndex: undefined,
      promptDC: false,
      menu: [],
      submitting: false
    }
  },
  computed: {
    totalUsers() {
      if (this.filteredUsers) {
        return this.filteredUsers.length
      } else {
        return 0
      }
    },
    filteredUsers() {
      if (this.search && this.search !== '') {
        const result = this.backendUsers.filter(user => {
          const fullName = user.firstName + ', ' + user.lastName
          return fullName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        })
        return result
      } else {
        return this.backendUsers
      }
    },
    backendUsers() {
      if (this.users && this.users.length > 0) {
        return this.users.filter(x => x.mavModule === 'B')
      } else {
        return []
      }
    },
    selectedUser() {
      if (this.selectedIndex !== undefined) {
        return this.users[this.selectedIndex]
      } else {
        return {}
      }
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.$store.state.adminUser.menu.sessions
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.users = data
        }
        this.menu = extractMenu(result.data._links)
      } catch (err) {
        throw err
      }
    },
    doRefresh() {
      this.doInit()
      this.search = ''
      this.selectedIndex = undefined
      this.promptDC = false
      this.submitting = false
    },
    formatInitials(fname, lname) {
      return initials(fname, lname)
    },
    formatDateTime(dateTime) {
      return formatDisplayDateTime(dateTime)
    },
    doSelectUser(userId) {
      this.selectedIndex = userId
    },
    async doDC() {
      const apiURI = this.menu.disconnect
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            id: this.selectedUser.userId
          }
          const result = await this.$http.post(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.doRefresh()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    CardAvatar
  }
}
</script>

<style lang="scss">
</style>
